module.exports = __webpack_public_path__ + "static/media/torre-de-hanoi.95321b49.png";